/**
 * Pages in the original candidate availability request modal.
 */
export enum CandidateAvailabilityOptionsModalPage {
  BASIC_CONFIGURATION = 0,
  SAVE_SUCCESS = 1,
  SHARE_AVAILABILITY = 2,
  DELETE_AVAILABILITY_CONFIRMATION = 3,
  CREATE_TASK = 4,
}
